import React from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';
import WhsLinkOperationStatus from 'common/Accounts/WhsLinkOperationStatus';

const LinkWhsOperationStatus = ({
  accountWhsLinkStatus,
  accountWhsLinkMonitorFailed,
  showExplanation,
  history
}) => (
  <React.Fragment>
    {accountWhsLinkStatus && accountWhsLinkStatus.createdBy && (accountWhsLinkStatus.createdBy.fullName || accountWhsLinkStatus.createdBy.emailAddress)
    && <p>Linking of this structure started by { accountWhsLinkStatus.createdBy.fullName } ({ accountWhsLinkStatus.createdBy.emailAddress })</p>}
    { showExplanation && <React.Fragment>
      <p>For simple IMY Structure this will take a few seconds. For larger structures this may take a few minutes.</p>
      <p>The IMY Structure and Linked Accounts will <strong>not</strong> be editable until the linking is complete.</p>
    </React.Fragment> }
    {!accountWhsLinkMonitorFailed
    && <React.Fragment>
        {(accountWhsLinkStatus === null || accountWhsLinkStatus === undefined || (accountWhsLinkStatus && accountWhsLinkStatus.linkedBos === 0))
      && <React.Fragment>
          {((accountWhsLinkStatus === null || accountWhsLinkStatus === undefined) || (accountWhsLinkStatus && accountWhsLinkStatus.status === WhsLinkOperationStatus.New))
          && <React.Fragment>
            <progress id="progress-bar" style={ { width: '100%' } } />
            <p>Fetching Data...</p>
          </React.Fragment>}
          {accountWhsLinkStatus && (accountWhsLinkStatus.status >= WhsLinkOperationStatus.Ready && accountWhsLinkStatus.status < WhsLinkOperationStatus.Linking)
          && <React.Fragment>
            <progress id="progress-bar" style={ { width: '100%' } } />
            <p>Starting linking...</p>
          </React.Fragment>}
      </React.Fragment>}
      {accountWhsLinkStatus && accountWhsLinkStatus.status >= WhsLinkOperationStatus.Linking && accountWhsLinkStatus.status <= WhsLinkOperationStatus.Completed
      && <React.Fragment>
        <progress id="progress-bar" value={ accountWhsLinkStatus.linkedBos } max={ accountWhsLinkStatus.totalBos } style={ { width: '100%' } } />
        <p>{accountWhsLinkStatus.linkedBos}/{accountWhsLinkStatus.totalBos} Beneficiaries Linked</p>
        </React.Fragment>}
    </React.Fragment>}
    {accountWhsLinkMonitorFailed
     && <div className="d-inline-flex" style={ { alignItems: 'baseline', width: '100%', justifyContent: 'space-between' } }>
       <p style={ { color: 'red' } }>An error has occured. Please go back a page and try again.</p>
       <button
         type="button"
         className="btn btn-primary"
         title="Go back a page"
         onClick={ () => { history.goBack(); } }
       >
         <span>Go back</span>
       </button>
     </div>}
  </React.Fragment>
);

LinkWhsOperationStatus.propTypes = {
  accountWhsLinkStatus: PropTypes.shape(),
  accountWhsLinkMonitorFailed: PropTypes.bool,
  showExplanation: PropTypes.bool,
  history: PropTypes.shape().isRequired
};

LinkWhsOperationStatus.defaultProps = {
  accountWhsLinkStatus: null,
  accountWhsLinkMonitorFailed: false,
  showExplanation: true
};

export default withRouter(LinkWhsOperationStatus);
